// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ArrangeAToZIconSignature {
  Element: SVGSVGElement;
}

export const ArrangeAToZIcon: TOC<ArrangeAToZIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 2H20C20.552 2 21 2.447 21 3V10H19V8H17V10H15V3C15 2.448 15.448 2 16 2ZM17 4V6H19V4H17ZM20.832 15.555C21.037 15.248 21.056 14.854 20.882 14.529C20.708 14.203 20.369 14 20 14H15V16H18.131L15.168 20.445C14.963 20.752 14.944 21.146 15.118 21.471C15.292 21.797 15.631 22 16 22H21V20H17.869L20.832 15.555ZM9 3V17.586L11.293 15.293L12.707 16.707L8 21.414L3.293 16.707L4.707 15.293L7 17.586V3H9Z"/>
</svg>
</template>;